import React from 'react';

import Gravatar from 'react-gravatar'


export default props => {
    const {url, width, height, email} = props

    return (
        <>
            {url ? (
                <img
                    src={url}
                    width={width}
                    height={height}
                    className="author-profile-image"
                    loading="lazy"
                />
            ) : (
                <Gravatar
                    email={email}
                    size={+width}
                    className="author-profile-image"
                />
            )}
        </>
    )
}